import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users, Trash2, Ban, ShieldOff } from "lucide-react";
import { api } from "@/lib/api";

const Tile = ({ label, value }) => (
  <div className="rounded-2xl border border-zinc-700 bg-zinc-800/50 p-4">
    <p className="text-xs text-zinc-400">{label}</p>
    <p className="mt-1 font-heading text-2xl font-extrabold text-white">{value ?? "—"}</p>
  </div>
);

export const CommunityAdmin = () => {
  const [ov, setOv] = useState(null);
  const [reports, setReports] = useState([]);

  const load = () => {
    api.communityAdminOverview().then(setOv).catch(() => {});
    api.communityAdminReports().then((r) => setReports(r.reports || [])).catch(() => {});
  };
  useEffect(load, []);

  const act = async (fn, ok) => {
    try { await fn(); toast.success(ok); load(); } catch (e) { toast.error(e.message || "Gagal"); }
  };

  return (
    <div className="mt-8" data-testid="admin-community-section">
      <div className="mb-3 flex items-center gap-2">
        <Users className="h-5 w-5 text-emerald-400" />
        <h2 className="font-heading text-lg font-extrabold text-white">Komunitas Premium</h2>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        <Tile label="Total Premium" value={ov?.totalPremium} />
        <Tile label="User Aktif" value={ov?.activeUsers} />
        <Tile label="Pesan Hari Ini" value={ov?.messagesToday} />
        <Tile label="Pesan Bulan Ini" value={ov?.messagesMonth} />
        <Tile label="Laporan Terbuka" value={ov?.openReports} />
        <Tile label="Dibatasi/Diblokir" value={ov?.restrictedBanned} />
      </div>

      <div className="mt-5 rounded-2xl border border-zinc-700 bg-zinc-800/50 p-4">
        <p className="mb-3 font-heading text-sm font-bold text-white">Pesan Dilaporkan</p>
        {reports.length === 0 ? (
          <p className="text-xs text-zinc-500">Tidak ada laporan terbuka.</p>
        ) : (
          <div className="space-y-3">
            {reports.map((r) => (
              <div key={r.id} data-testid={`admin-report-${r.id}`} className="rounded-xl border border-zinc-700 p-3">
                <p className="text-sm text-zinc-200">
                  <b>{r.message?.displayName || "?"}:</b> {r.message?.text || "(pesan tidak ditemukan)"}
                </p>
                {r.reason ? <p className="mt-1 text-xs text-amber-400">Alasan: {r.reason}</p> : null}
                <div className="mt-2 flex flex-wrap gap-2">
                  <button
                    data-testid={`admin-delete-${r.id}`}
                    onClick={() => act(() => api.communityDelete(r.messageId), "Pesan dihapus")}
                    className="inline-flex items-center gap-1 rounded-full bg-rose-600/20 px-3 py-1 text-xs font-semibold text-rose-300"
                  >
                    <Trash2 className="h-3 w-3" /> Hapus Pesan
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <ModByUser act={act} />
    </div>
  );
};

const ModByUser = ({ act }) => {
  const [uid, setUid] = useState("");
  return (
    <div className="mt-5 rounded-2xl border border-zinc-700 bg-zinc-800/50 p-4">
      <p className="mb-2 font-heading text-sm font-bold text-white">Moderasi User (pakai User ID)</p>
      <input
        data-testid="admin-mod-uid"
        value={uid}
        onChange={(e) => setUid(e.target.value.trim())}
        placeholder="User ID"
        className="mb-3 h-10 w-full rounded-xl border border-zinc-600 bg-zinc-900 px-3 text-sm text-white outline-none"
      />
      <div className="flex flex-wrap gap-2">
        <button
          data-testid="admin-restrict"
          disabled={!uid}
          onClick={() => act(() => api.communityRestrict(uid), "User dibatasi 7 hari")}
          className="inline-flex items-center gap-1 rounded-full bg-amber-600/20 px-3 py-1.5 text-xs font-semibold text-amber-300 disabled:opacity-40"
        >
          <ShieldOff className="h-3.5 w-3.5" /> Batasi 7 hari
        </button>
        <button
          data-testid="admin-ban"
          disabled={!uid}
          onClick={() => act(() => api.communityBan(uid), "User diblokir dari komunitas")}
          className="inline-flex items-center gap-1 rounded-full bg-rose-600/20 px-3 py-1.5 text-xs font-semibold text-rose-300 disabled:opacity-40"
        >
          <Ban className="h-3.5 w-3.5" /> Blokir
        </button>
        <button
          data-testid="admin-unban"
          disabled={!uid}
          onClick={() => act(() => api.communityUnban(uid), "Pembatasan dicabut")}
          className="inline-flex items-center gap-1 rounded-full bg-emerald-600/20 px-3 py-1.5 text-xs font-semibold text-emerald-300 disabled:opacity-40"
        >
          Cabut
        </button>
      </div>
      <p className="mt-2 text-[11px] text-zinc-500">Blokir komunitas TIDAK menghapus akun atau data keuangan user.</p>
    </div>
  );
};
